<template>
  <section id="settings" class="container main-container" v-if="gallery">
    <div class="columns">
      <div class="column is-8">
        <h1 class="title">{{ gallery.name }}</h1>
        <p class="preserve" v-html="gallery.description"></p>
        <p>{{ gallery.sport }}</p>
        <p>{{ gallery.place }}</p>
        <p>{{ gallery.dates }}</p>
      </div>
      <div class="column">
        <img class="image" :src="imageUrl" />
      </div>
    </div>
    <hr />

    <form v-on:submit.prevent="doSearch">
      <div class="columns">
        <div class="column is-4">
          <div class="label">Dorsal:</div>

          <input
            class="input"
            type="number"
            v-model="searchText"
            :disabled="search.length > 0"
          />

          <button type="submit" class="add button is-primary">Buscar</button>
          <hr>
          <br>
          <div class="label">Fecha/hora:</div>
          
          <input
            class="input"
            type="text"
            v-model="searchDate"
            placeholder="YYYY-MM-DD"
            :disabled="search.length > 0"
          />

          <input
            class="input"
            type="text"
            v-model="searchTime"
            placeholder="HH:mm"
            :disabled="search.length > 0"
          />

          <button
            type="button"
            @click="searchByTime"
            class="add button is-primary"
          >
            Buscar
          </button>
        </div>
        <div class="column is-8">
          <div class="searchs">
            <div class="zcolumn" v-if="searchListsTShirt">
              <div class="tag-cont">
                <div class="label">
                  {{ searchListsTShirt.text }}
                </div>
                <div
                  class="tag"
                  v-bind:style="{
                    backgroundColor: value.code,
                  }"
                  v-bind:class="{
                    selected: search.includes(
                      searchListsTShirt.code + ':' + value.code
                    ),
                  }"
                  v-for="value in searchListsTShirt.values"
                  v-bind:key="value.code"
                  v-on:click="addField(searchListsTShirt, value)"
                >
                  <i
                    class="material-icons"
                    v-if="
                      search.includes(searchListsTShirt.code + ':' + value.code)
                    "
                    >check</i
                  >
                </div>
              </div>
            </div>
            <div class="zcolumn" v-if="searchListsPants">
              <div class="tag-cont">
                <div class="label">
                  {{ searchListsPants.text }}
                </div>
                <div
                  class="tag"
                  v-bind:style="{
                    backgroundColor: value.code,
                  }"
                  v-bind:class="{
                    selected: search.includes(
                      searchListsPants.code + ':' + value.code
                    ),
                  }"
                  v-for="value in searchListsPants.values"
                  v-bind:key="value.code"
                  v-on:click="addField(searchListsPants, value)"
                >
                  <i
                    class="material-icons"
                    v-if="
                      search.includes(searchListsPants.code + ':' + value.code)
                    "
                    >check</i
                  >
                </div>
              </div>
            </div>
            <div
              class="zcolumn"
              v-for="list in searchListsOther"
              v-bind:key="list.code"
            >
              <div class="tag-cont">
                <div class="label">
                  {{ list.text }}
                </div>
                <div
                  class="tag"
                  v-bind:class="{
                    selected: search.includes(list.code + ':' + value.code),
                  }"
                  v-for="value in list.values"
                  v-bind:key="value.code"
                  v-on:click="addField(list, value)"
                >
                  <i
                    class="material-icons"
                    v-bind:class="{
                      'unselected-text': !search.includes(
                        list.code + ':' + value.code
                      ),
                    }"
                    >check</i
                  >
                  {{ value.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <hr />
    <p class="tag is-warning">{{ results ? results.length : 0 }} resultados</p>
    <div class="results columns is-multiline">
      <div
        class="column with-image is-3"
        v-for="result in results"
        v-bind:key="result.id"
      >
        <a :href="result.imageUrl" target="_blank">
          <img class="result-image" v-lazy="result.imageUrl" />
        </a>
      </div>
    </div>
    <!-- <pre>{{ results }}</pre> -->
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebase");
import axios from "axios";
import { EventBus } from "../services/event-bus.js";
import firebase from "firebase";
const storage = firebase.storage();
const storageRef = firebase.storage().ref();
import moment from 'moment'

export default {
  components: {},
  data() {
    return {
      galleryId: "",
      gallery: {},
      imageUrl: "",
      searchText: "",
      search: [],
      results: {},
      searchTime: "",
      searchDate: "",
    };
  },
  computed: {
    ...mapState(["userProfile"]),

    searchListsTShirt() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.find(
        (l) => l.code == "color-tshirt"
      );
      return list ? list : [];
    },
    searchListsPants() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.find(
        (l) => l.code == "color-pants"
      );
      return list ? list : [];
    },
    searchListsOther() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.filter(
        (l) => l.code !== "color-tshirt" && l.code !== "color-pants"
      );
      return list ? list : [];
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.galleryId = this.$route.params.id;
      this.viewGallery();
    }
  },
  methods: {
    viewGallery() {
      fb.galleriesCollection
        .doc(this.galleryId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.gallery = doc.data();
            this.gallery.id = this.galleryId;

            this.loadImage();

            this.viewSome();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async loadImage() {
      if (this.gallery.image && this.gallery.image !== "") {
        var fileRef = storage.ref(
          `gallery-info/${this.gallery.id}/${this.gallery.image}`
        );
        this.imageUrl = await fileRef.getDownloadURL();
      }
    },
    async viewSome() {
      //console.log('search', this.search)
      axios
        .get(
          `${process.env.VUE_APP_API}images?galleryId=${this.galleryId}&startAfter=`
        )
        .then((result) => {
          this.results =
            result.data && result.data.images ? result.data.images : [];
        });
    },
    async doSearch() {
      if (this.searchText === "" && this.search.length == 0) {
        this.viewSome();
        return;
      }

      const search = encodeURI(this.search.join(";"));
      //console.log('search',search)
      axios
        .get(
          `${process.env.VUE_APP_API}search?galleryId=${this.galleryId}&number=${this.searchText}&search=${search}`
        )
        .then((result) => {
          this.results =
            result.data && result.data.images ? result.data.images : [];
        });
    },
    async addField(list, value) {
      const search = `${list.code}:${value.code}`;
      let action = "";
      if (this.search.includes(search)) {
        this.search = this.search.filter((s) => s !== search);
        action = "remove";
      } else {
        this.search.push(`${list.code}:${value.code}`);
        action = "add";
      }
      //console.log('this.search', this.search)
      if (this.search.length > 0) {
        this.searchText = "";
      }
    },
    async searchByTime() {
      const gmt = this.gallery.gmt || 0

      const searchDateTime = `${this.searchDate}T${this.searchTime}:00.000Z`
      console.log('searchDateTime', searchDateTime)
      const searchMoment = moment(searchDateTime, 'YYYY-MM-DD HH:mm:00.000Z').add(gmt, 'hours')
      const searchUnix = searchMoment.unix()
      console.log('searchUnix', searchUnix)

      axios
        .get(
          `${process.env.VUE_APP_API}search?galleryId=${this.galleryId}&unixCreateDate=${searchUnix}&unixDelta=300`
        )
        .then((result) => {
          this.results =
            result.data && result.data.images ? result.data.images : [];
        });

    }
  },
};
</script>
<style scoped>
#settings {
  margin-top: 4rem;
}
.preserve {
  white-space: pre-line;
}
.reset {
  margin-left: 1rem;
}
.searchs .tag {
  margin-right: 0.5rem;
  min-width: 50px;
  border: 1px solid #666;
  cursor: pointer;
  padding: 0.5rem;
  color: #333;
}
.unselected-text {
  color: transparent;
}
</style>
